import { determinePageAssetId } from "./DeterminePageAssetId.function";

export function withoutEmptyPageAssetIds(page) {
    const pageAssetId = determinePageAssetId(page);
    return pageAssetId !== null && pageAssetId !== "";
}
